import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";

interface IncompleteBatchDialogProps {
  open: boolean;
  onStay: () => void;
  onGoToUnlabeled: () => void;
}

const IncompleteBatchDialog: React.FC<IncompleteBatchDialogProps> = ({
  open,
  onStay,
  onGoToUnlabeled,
}) => (
  <Dialog open={open}>
    <DialogTitle>Lot incomplet</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Certaines vidéos n'ont pas encore été labelisées. Voulez-vous aller à la
        première vidéo non labelisée ?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button color="primary" onClick={onStay}>
        Rester ici
      </Button>
      <Button color="primary" onClick={onGoToUnlabeled}>
        Aller à la vidéo
      </Button>
    </DialogActions>
  </Dialog>
);

export default IncompleteBatchDialog;
